import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default, { createContext, useMemo, useContext, forwardRef } from 'react';
import { useFocusVisible } from '@react-aria/interactions';

const A11yHelpersContext = /*#__PURE__*/createContext(undefined);
const A11yHelpersProvider = _ref => {
  let {
    children
  } = _ref;
  const focusVisible = useFocusVisible();
  const textInputFocusVisible = useFocusVisible({
    isTextInput: true
  });
  const focusVisibleProvider = useMemo(() => ({
    focusVisible,
    textInputFocusVisible
  }), [focusVisible, textInputFocusVisible]);
  return /*#__PURE__*/React__default.createElement(A11yHelpersContext.Provider, {
    value: focusVisibleProvider
  }, children);
};
const A11yHelpersProviderDefault = _ref2 => {
  let {
    children
  } = _ref2;
  const focusVisible = useFocusVisible();
  const focusVisibleProvider = useMemo(() => ({
    focusVisible
  }), [focusVisible]);
  return /*#__PURE__*/React__default.createElement(A11yHelpersContext.Provider, {
    value: focusVisibleProvider
  }, children);
};
const A11yHelpersProviderTextInput = _ref3 => {
  let {
    children
  } = _ref3;
  const textInputFocusVisible = useFocusVisible({
    isTextInput: true
  });
  const focusVisibleProvider = useMemo(() => ({
    textInputFocusVisible
  }), [textInputFocusVisible]);
  return /*#__PURE__*/React__default.createElement(A11yHelpersContext.Provider, {
    value: focusVisibleProvider
  }, children);
};
const useIsFocusVisible = function () {
  let isTextInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const a11yHelpersContext = useContext(A11yHelpersContext);
  return (isTextInput ? a11yHelpersContext === null || a11yHelpersContext === void 0 ? void 0 : a11yHelpersContext.textInputFocusVisible : a11yHelpersContext === null || a11yHelpersContext === void 0 ? void 0 : a11yHelpersContext.focusVisible) || {
    isFocusVisible: false
  };
};
const conditionalA11yHelpersWrapper = function (Children) {
  let mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  return /*#__PURE__*/forwardRef((props, ref) => {
    const a11yContext = useContext(A11yHelpersContext);
    if (a11yContext) {
      return /*#__PURE__*/React__default.createElement(Children, _extends({}, props, {
        ref: ref
      }));
    }
    switch (mode) {
      case 'default':
        return /*#__PURE__*/React__default.createElement(A11yHelpersProviderDefault, null, /*#__PURE__*/React__default.createElement(Children, _extends({}, props, {
          ref: ref
        })));
      case 'textInput':
        return /*#__PURE__*/React__default.createElement(A11yHelpersProviderTextInput, null, /*#__PURE__*/React__default.createElement(Children, _extends({}, props, {
          ref: ref
        })));
      default:
        return /*#__PURE__*/React__default.createElement(A11yHelpersProvider, null, /*#__PURE__*/React__default.createElement(Children, _extends({}, props, {
          ref: ref
        })));
    }
  });
};

export { A11yHelpersProvider, conditionalA11yHelpersWrapper, useIsFocusVisible };
